import { render } from "./singlemeasurement.vue?vue&type=template&id=f4770ed6&scoped=true"
import script from "./singlemeasurement.vue?vue&type=script&lang=js"
export * from "./singlemeasurement.vue?vue&type=script&lang=js"

import "./singlemeasurement.vue?vue&type=style&index=0&id=f4770ed6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4770ed6"]])

export default __exports__